import React from "react";
import { Alert, Button, Modal, Table, Typography } from "antd";
import "./HotelProfileRoomPriceMagnifierModal.css";

const { Text, Title } = Typography;

export default function HotelProfileRoomPriceMagnifierModal({ open, onClose, trace }) {
  if (!trace) return null;

  const isPass = trace.status === "PASS";
  const columns = [
    {
      title: "Field",
      dataIndex: "field",
      key: "field",
      width: "32%",
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      width: "38%",
      render: (v) => <Text code={false}>{v ?? "—"}</Text>,
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
      width: "30%",
      render: (v) => (
        <Text type="secondary" style={{ fontSize: 12 }}>
          {v ?? "—"}
        </Text>
      ),
    },
  ];

  const width =
    typeof window !== "undefined" ? Math.min(920, Math.max(360, window.innerWidth - 32)) : 920;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={<Button onClick={onClose}>סגור</Button>}
      width={width}
      className="hrpm-modal"
      destroyOnHidden
      centered
      title={
        <div className="hrpm-modal__head">
          <Title level={4} style={{ margin: 0 }}>
            Room price debug
          </Title>
          <Text type="secondary">
            {trace.entityName || "—"} · package {trace.entityId ?? "—"}
          </Text>
        </div>
      }
    >
      <div className="hrpm-modal__body">
        <Alert
          type={isPass ? "success" : "error"}
          showIcon
          message={`Status: ${trace.status}`}
          description={trace.statusDetail}
          className="hrpm-modal__status"
        />

        {Array.isArray(trace.warnings) && trace.warnings.length > 0 ? (
          <div className="hrpm-modal__warnings">
            {trace.warnings.map((w) => (
              <Alert
                key={w.code}
                type="warning"
                showIcon
                message={w.message}
                className="hrpm-modal__warn-item"
              />
            ))}
          </div>
        ) : null}

        <Table
          size="small"
          pagination={false}
          columns={columns}
          dataSource={(trace.fields || []).map((row, i) => ({ ...row, key: String(i) }))}
          className="hrpm-modal__table"
        />
      </div>
    </Modal>
  );
}
